import { getCookie, setCookie } from '../utils/cookie';

document.querySelectorAll('.closable').forEach((el) => {
  if (!getCookie(`wp-vb-closable-` + el.id)) {
    el.classList.remove('closable');
    const container = el.querySelector('.container');

    if (container) {
      const wrapper = document.createElement('div');
      const button = document.createElement('button');
      const icon = document.createElement('i');

      button.setAttribute('aria-label', 'close');

      wrapper.className = 'closable__wrapper';
      button.className = 'top-bar__close-button closable__button';
      icon.className = 'icon-cross';

      button.append(icon);
      wrapper.append(button);
      container.prepend(wrapper);

      button.addEventListener('click', () => {
        setCookie(`wp-vb-closable-` + el.id, 'hidden', 30);
        el.classList.add('closable');
      });
    }
  }
});